import styled from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'

const DOT_SIZE = 8
const DOT_SIZE_ACTIVE = 12

export const TouchScroller = styled.div<{ spaceBetweenItems?: string }>`
  display: flex;
  align-items: stretch;
  gap: ${({ spaceBetweenItems }) => spaceBetweenItems || '0px'};

  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;

  scroll-snap-type: x proximity;
  scroll-padding-left: 10px;
  padding: 10px 10px 16px;
  margin: 0;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  > * {
    flex: 0 0 auto;
    scroll-snap-align: start;
  }
`

export const SliderWrapper = styled.div<{ spaceBetweenItems?: string }>`
  margin: 0px;

  @media (min-width: ${tokens.sizes.mdScreen}px) {
    margin-left: -${tokens.spacing.horizontalXsmall};
  }

  .slick-slider {
    position: relative;
    width: auto !important;
    display: block;
    box-sizing: border-box;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }

  .slick-list {
    position: relative;
    overflow: hidden;
    margin: 0;
    padding: 0 0 16px 10px;
  }

  .slick-list:focus {
    outline: none;
  }

  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }

  .slick-slider .slick-track,
  .slick-slider .slick-list {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  .slick-track {
    position: relative;
    top: 0;
    left: 0;
    display: flex;

    padding: 10px 0 10px 0;
    @media (min-width: ${tokens.breakpoints.tablet}px) {
      padding-left: ${tokens.spacing.horizontalXsmall};
    }
  }
  .slick-track:before,
  .slick-track:after {
    display: table;

    content: '';
  }
  .slick-track:after {
    clear: both;
  }
  .slick-loading .slick-track {
    visibility: hidden;
  }

  .slick-slide {
    display: none;
    float: left;

    height: 100%;
    min-height: 1px;
    margin-right: ${({ spaceBetweenItems }) =>
      spaceBetweenItems ? spaceBetweenItems : 0};
  }
  [dir='rtl'] .slick-slide {
    float: right;
  }
  .slick-slide img {
    display: block;
  }
  .slick-slide.slick-loading img {
    display: none;
  }
  .slick-slide.dragging img {
    pointer-events: none;
  }
  .slick-initialized .slick-slide {
    display: block;
  }
  .slick-loading .slick-slide {
    visibility: hidden;
  }
  .slick-vertical .slick-slide {
    display: block;

    height: auto;

    border: 1px solid transparent;
  }
  .slick-arrow.slick-hidden {
    display: none;
  }

  .slick-disabled {
    display: none !important;
  }
`

const ArrowSlick = styled.div`
  background-color: ${tokens.colors.white};
  color: transparent;
  border-radius: ${tokens.radius.circular};
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
  padding: 5px;
  border: 1px solid ${tokens.colors.dark1};

  &:focus-visible {
    outline: 2px solid ${tokens.colors.dark5};
    outline-offset: 2px;
  }
  width: 40px;
  height: 40px;
  position: absolute;
  top: calc(50% - 22px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  cursor: pointer;
  right: -18px;

  @media (max-width: ${tokens.sizes.smScreen}px) {
    display: none !important;
  }

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    .slick-disabled {
      display: none !important;
    }
  }

  &.slick-hidden {
    display: none;
  }
`

export const ArrowNextStyled = styled(ArrowSlick)`
  right: -18px;
`

export const ArrowPrevStyled = styled(ArrowSlick)`
  left: -16px;
`

export const StyledCarouselBanner = styled.div`
  margin-bottom: 26px;
  border-radius: ${tokens.radius.xlarge};
  transition: all ${tokens.transitions.motionModerate2};

  @media (hover: hover) {
    &:hover {
      transform: scale(1.03);
      transition: all ${tokens.transitions.motionModerate2};
      box-shadow: ${tokens.shadows.downLarge};

      img {
        filter: opacity(0.88);
        transition: all ${tokens.transitions.motionModerate2};
      }

      .slick-arrow {
        display: flex;
        opacity: 1;
      }
    }
  }

  .slick-arrow {
    opacity: 0;
    transition: all ${tokens.transitions.motionModerate2};
  }

  .slick-slide:not(.slick-active) {
    pointer-events: none;
  }

  .slick-list {
    border-radius: ${tokens.radius.xlarge};
  }

  img {
    width: 100%;
    border-radius: ${tokens.radius.xlarge};
  }

  ul.slick-dots {
    display: flex !important;
    position: relative;
    padding: 0 10px;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    right: 10px;
    background-color: rgba(5, 59, 75, 0.6);
    border-radius: ${tokens.radius.radius_50}px;
    opacity: 0.5;

    li {
      position: relative;
      display: flex;
      margin: 0 3px;

      &.slick-active::before {
        background-color: ${tokens.colors.white};
        width: ${DOT_SIZE_ACTIVE}px;
        left: calc(50% - ${DOT_SIZE_ACTIVE / 2}px);

        transition: all 300ms linear;
      }

      &::before {
        transition: all 300ms linear;

        content: '';
        position: absolute;
        display: inline-block;
        width: ${DOT_SIZE}px;
        height: ${DOT_SIZE}px;
        border-radius: ${DOT_SIZE / 2}px;
        background-color: ${tokens.colors.primaryLight};
        left: calc(50% - ${DOT_SIZE / 2}px);
        top: calc(50% - ${DOT_SIZE / 2}px);
      }

      button {
        opacity: 0;
        cursor: pointer;
      }
    }
  }

  @media (max-width: ${tokens.sizes.smScreen}px) {
    margin-bottom: 0;
    border-radius: ${tokens.radius.large};
    box-shadow: none;

    .slick-track {
      margin: auto;
    }

    .slick-slide.slick-active {
      transition: opacity 500ms ease-in-out;
    }

    .slick-slide:not(.slick-active) {
      opacity: 0.5;
      transition: opacity 500ms ease-in-out;
    }

    .slick-list {
      border-radius: ${tokens.radius.large};
    }

    img {
      border-radius: ${tokens.radius.large};
    }

    ul.slick-dots {
      bottom: 30px;
      opacity: 1;
      display: table !important;
      margin: auto;
      position: relative;
      right: auto;

      li {
        display: inline-block;
      }
    }
  }
`

export const ImageContainer = styled.div`
  @media (max-width: ${tokens.sizes.mdScreen}px) {
    padding: 0 4px;
  }

  a {
    cursor: pointer;
    display: flex;
  }
`
